import sysFileChoose from '../../components/sys-file-choose/index.vue';
export default {
    data() {
        return {
            baseUrl: this.$global.baseUrl,
            searchContent: "",
            subjectType: null,
            pageIndex: 1,
            pageSize: 12,
            total: 0,
            tableData: [],
            multipleSelection: [],
            dialogManageShow: false,
            manageForm: {},
            fileChooseDialogShow: false,
            optionList: [],
            optionDialogShow: false,
            uploadFileList: [],
            clearDialogShow: false,
            countdown: 8
        }
    },
    components: { sysFileChoose },
    mounted: function () {
        this.query()
    },
    methods: {
        /**
         * 点击事件
         * @param {*} id 
         */
        clickEvent: function (id, data) {
            switch (id) {
                case "search": //搜索
                    this.pageIndex = 1;
                    this.query();
                    break;
                case "add": //添加
                    this.manageForm = {
                        id: null,
                        title: "",
                        subjectType: 1,
                        fileInfo: null,
                        options: [{
                            name: "",
                            rightAnswer: true
                        }]
                    };
                    this.dialogManageShow = true;
                    break;
                case "edit": //编辑
                    if (this.multipleSelection.length != 1) {
                        this.$message.closeAll();
                        this.$message.warning("请选择一项进行修改");
                        return;
                    }
                    this.manageForm = Object.assign({}, this.multipleSelection[0]);
                    this.queryOptions(1, this.manageForm.id);
                    this.manageForm.fileInfo = {
                        fileType: this.manageForm.fileType,
                        id: this.manageForm.fileInfoId,
                        name: this.manageForm.fileName,
                        path: this.manageForm.filePath,
                        suffix: this.manageForm.fileSuffix
                    }
                    this.dialogManageShow = true;
                    break;
                case "manageConfirm": //确定
                    this.$refs['manageForm'].validate((valid) => {
                        if (valid) {
                            if (this.manageForm.fileInfo == null) {
                                this.$message.closeAll();
                                this.$message.warning("请选择关联资料");
                                return;
                            }
                            var rightAnswerCount = 0;
                            this.manageForm.options.forEach(elem => {
                                rightAnswerCount += elem.rightAnswer ? 1 : 0;
                            });
                            if (rightAnswerCount == 0) {
                                this.$message.closeAll();
                                this.$message.warning("试题选项配置不规范，缺少正确答案");
                                return;
                            }
                            this.saveOrUpdate();
                        } else {
                            return false;
                        }
                    });
                    break;
                case "delete": //删除
                    if (this.multipleSelection.length == 0) {
                        this.$message.closeAll();
                        this.$message.warning("请至少选择一项进行删除");
                        return;
                    }
                    this.$confirm('此操作将删除所选中的试题, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.delete();
                    }).catch(() => { });
                    break;
                case "optionAdd": //新增选项
                    if (this.manageForm.options.length == 10) {
                        this.$message.closeAll();
                        this.$message.warning("选项过多");
                        return;
                    }
                    this.manageForm.options.push({
                        id: null,
                        subjectId: this.manageForm.id,
                        name: "",
                        rightAnswer: false
                    });
                    break;
                case "optionRemove": //点击移除
                    var options = this.manageForm.options;
                    options.splice(data, 1);
                    this.manageForm.options = options;
                    break;
                case "fileChoose"://文件选择
                    this.fileChooseDialogShow = true;
                    break;
                case "subjectOption"://查看选项
                    this.queryOptions(2, data.id);
                    break;
                case "clear"://清库
                    this.countdown = 8;
                    this.doCountdown();
                    this.clearDialogShow = true;
                    break;
                case "clearConfirm"://确认清库
                    this.clearDialogShow = false;
                    this.clearSubject();
                    break;
                default:
                    break;
            }
        },

        /**
         * 进行倒计时
         */
        doCountdown: function () {
            setTimeout(() => {
                this.countdown = this.countdown - 1;
                if (this.countdown > 0)
                    this.doCountdown();
            }, 1000);
        },

        /**
         * 关闭文件选择弹框
         */
        onFileChooseDialogClose: function () {
            this.fileChooseDialogShow = false;
        },

        /**
         * 选择文件完成回调
         * @param {*} selectedFileList 
         */
        onFileChooseCallback: function (selectedFileList) {
            this.fileChooseDialogShow = false;
            if (selectedFileList != null && selectedFileList.length > 0)
                this.manageForm.fileInfo = selectedFileList[0];
        },

        /**
         * 阿拉伯数组转中文数字
         * @param {*} index 
         */
        getChineseByIndex: function (index) {
            switch (index) {
                case 0:
                    return "零";
                case 1:
                    return "一";
                case 2:
                    return "二";
                case 3:
                    return "三";
                case 4:
                    return "四";
                case 5:
                    return "五";
                case 6:
                    return "六";
                case 7:
                    return "七";
                case 8:
                    return "八";
                case 9:
                    return "九";
                case 10:
                    return "十";
            }
        },

        /**
         * 阿拉伯数字转大写字母
         * @param {*} index 
         */
        getLetterByIndex: function (index) {
            switch (index) {
                case 0:
                    return "-";
                case 1:
                    return "A";
                case 2:
                    return "B";
                case 3:
                    return "C";
                case 4:
                    return "D";
                case 5:
                    return "E";
                case 6:
                    return "F";
                case 7:
                    return "G";
                case 8:
                    return "H";
                case 9:
                    return "I";
                case 10:
                    return "J";
            }
        },

        /**
         * checkebox change事件
         * @param {*} val 
         */
        handleOption: function (val, index) {
            let subjectType = this.manageForm.subjectType;
            if (subjectType == 1 || subjectType == 3) { //单选 || 判断
                let options = this.manageForm.options;
                var rightCount = 0;
                options.forEach(elem => {
                    rightCount += elem.rightAnswer ? 1 : 0
                });
                if (rightCount == 0) {
                    this.manageForm.options[index].rightAnswer = true;
                } else {
                    options.forEach(elem => {
                        elem.rightAnswer = false;
                    });
                    this.manageForm.options[index].rightAnswer = true;
                }
            }
        },

        /**
         * 表格选中事件
         * @param {*} val 
         */
        tableColumnCheckEvent: function (val) {
            this.multipleSelection = val;
        },

        /**
         * 翻页操作
         */
        handlePageChange: function (val) {
            this.pageIndex = val;
            this.query();
        },

        /**
         * 上传失败
         * @param {*} files 
         * @param {*} fileList 
         */
        handleError: function (err, file, fileList) {
            this.$message.closeAll();
            this.$message.error("上传失败");
        },

        /**
         * 上传成功
         * @param {*} response 
         * @param {*} file 
         * @param {*} fileList 
         */
        handleSuccess: function (response, file, fileList) {
            this.uploadFileList = [];
            if (response.success) {
                //调用导入
                this.excelImport(response.data.id);
            } else {
                this.$message.closeAll();
                this.$message.error(response.message);
            }
        },

        /**
         * 关闭清库dialog
         */
        handleClearDialogClose: function () {
            this.clearDialogShow = false;
        },

        /**
         * 新增或修改
         */
        saveOrUpdate: function () {
            this.$post({
                url: "/subject/saveOrUpdate",
                params: {
                    id: this.manageForm.id,
                    title: this.manageForm.title,
                    subjectType: this.manageForm.subjectType,
                    fileInfoId: this.manageForm.fileInfo.id,
                    subjectOptionList: this.manageForm.options
                }
            }, true).then(res => {
                this.manageForm = {};
                this.dialogManageShow = false;
                this.$message.closeAll();
                this.$message.success("添加成功");
                this.query();
            });
        },

        /**
         * 批量删除
         */
        delete: function () {
            var ids = new Array();
            this.multipleSelection.forEach(elem => {
                ids.push(elem.id);
            });
            this.$post({
                url: "/subject/delete",
                params: {
                    ids: ids
                }
            }, true).then(res => {
                this.$message.closeAll();
                this.$message.success("删除成功");
                this.query();
            });
        },

        /**
         * 查询
         */
        query: function () {
            this.$post({
                url: 'subject/queryByPage',
                params: {
                    keyWord: this.searchContent,
                    subjectType: this.subjectType,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                }
            }, true).then(response => {
                this.total = response.total;
                this.tableData = response.data;
            });
        },

        queryOptions: function (type, subjectId) {
            this.$post({
                url: 'subject/queryOptions',
                params: {
                    id: subjectId
                }
            }, true).then(response => {
                if (type == 1) {
                    this.$set(this.manageForm, "options", response);
                    // this.manageForm.options = response;
                } else {
                    this.optionList = response;
                    this.optionDialogShow = true;
                }
            });
        },

        /**
         * 调用试题导入
         * @param {*} fileInfoId 
         */
        excelImport: function (fileInfoId) {
            this.$post({
                url: 'subject/excelImport',
                params: {
                    id: fileInfoId
                }
            }, true).then(response => {
                this.$message.closeAll();
                this.$message.success("导入成功");
                this.pageIndex = 1;
                this.query();
            });
        },

        /**
         * 清库
         */
        clearSubject: function () {
            this.$post({
                url: 'subject/clearSubject',
                params: {}
            }, true).then(response => {
                this.$message.closeAll();
                this.$message.success("操作成功");
                this.pageIndex = 1;
                this.query();
            });
        }
    }
}